<template>
  <div class="layout__search-state">
    <div class="layout__search-state-alert">{{ message.alert }}</div>
    <div class="layout__search-state-text">
      <template v-if="empty">{{ message.text }}</template>
      <template v-else>
        <div>{{ message.text.split('. ')[0] }}</div>
        <div>{{ message.text.split('. ')[1] }}</div>
      </template>
    </div>
    <div v-if="empty" class="layout__search-state-string">"{{ searchString }}"</div>
    <img
      :src="message.imgSource"
      class="layout__search-state-img"
      alt="Search State Illustration"
    />
    <ul class="layout__search-state-help">
      <li v-for="help in message.help" :key="help">{{ help }}</li>
    </ul>
    <ButtonText
      v-if="error"
      class="layout__search-state-support-btn"
      :button-text="t('general__text__support')"
      size="small"
      :icon-left="iconMail"
      @onClicked="handleSupport"
    />
  </div>
</template>
<script setup lang="ts">
import { toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import imageIllustrationEmpty from '@/design-system/assets/images/Illustration-Pictogram-Empty.svg'
import imageIllustrationError from '@/design-system/assets/images/Illustration-Pictogram-Error.svg'
import iconMail from '@/design-system/assets/icons/Icon-Mail.svg'
const { t } = useI18n()

const props = defineProps({
  empty: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  },
  searchString: {
    type: String,
    default: ''
  }
})
const { empty, error } = toRefs(props)
interface SEARCH_MESSAGE {
  alert: string
  text: string
  imgSource: string
  help: Array<string>
}
const message: SEARCH_MESSAGE = {
  alert: empty.value
    ? t('general__text__search-empty-alert')
    : t('general__text__search-error-alert'),
  text: empty.value ? t('general__text__search-empty-text') : t('general__text__search-error-text'),
  imgSource: empty.value ? imageIllustrationEmpty : imageIllustrationError,
  help: empty.value
    ? [
        t('general__text__search-empty-help-1'),
        t('general__text__search-empty-help-2'),
        t('general__text__search-empty-help-3')
      ]
    : [t('general__text__search-error-help-1'), t('general__text__search-error-help-2')]
}
function handleSupport() {
  window.open('mailto: support@digitalbuildings.ai?subject=ZDB support')
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/variables.scss';
.layout__search-state {
  color: variables.$color-text-primary;
  display: flex;
  flex-direction: column;
  grid-column: 5 / 11;
  row-gap: variables.$gap-xlarge;
  text-align: center;
  @include font-mixins.desktop-regular-paragraph;

  &-alert,
  &-string {
    @include font-mixins.desktop-bold-paragraph;
    @media screen and (max-width: 1024px) {
      @include font-mixins.mobile-bold-paragraph;
    }
  }
  &-text {
    display: flex;
    flex-direction: column;
    row-gap: variables.$gap-xlarge;

    @media screen and (max-width: 1024px) {
      @include font-mixins.mobile-regular-paragraph;
    }
  }
  &-img {
    margin: 0 auto;
    width: fit-content;
  }
  &-help {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    row-gap: variables.$gap-small;
    text-align: left;
    width: 60%;
    @media screen and (max-width: 1024px) {
      padding-left: variables.$padding-main-body;
      width: 70%;
    }
    @media screen and (max-width: 658px) {
      margin: 0;
      width: 100%;
    }
  }
  &-support-btn {
    color: variables.$color-primary;
    margin: 0 auto;
  }
  @media screen and (max-width: 1024px) {
    @include font-mixins.mobile-regular-paragraph;
    grid-column: 4 / 12;
  }
}
</style>
